module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/patients/create.component.css
// module id = ./src/app/views/patients/create.component.css
// module chunks = main